<div class="public-wrap">
  <div class="container">
    <div class="row">
      <div class="col-md-4 back-link-outer mb-0 d-flex">
        <a class="back-link" role="button" (click)="goBack()">
          <img alt="back-icon" src="../assets/images/back.svg" /> Back
        </a>
      </div>
      <div class="col-12">
        <h3 class="register-name mb-3 pb-2">Inquire Now</h3>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="auctionCode">
    <div class="auction-with-logo mb-3">
      <div class="left-logo">
        <img
          class="auction-logo"
          alt="auction-logo"
          AuctionDefaultImage
          *ngIf="auctionDetail"
          [image]="auctionDetail.clientLogo"
        />
      </div>
      <div class="right-logo">
        <div class="d-flex mb-2">
          <span class="card-badge no-card min-width-auto badge-dark">
            {{ auctionDetail?.saleType.publicName }}</span
          >
        </div>
        <h3 class="auc-name mb-2">{{ auctionDetail?.title }}</h3>
        <p class="auc-des mb-3" [innerHTML]="auctionDetail?.tagline"></p>
        <p class="auc-location mb-2">
          {{ auctionDetail?.auctionLocations | locationNames }}
        </p>
        <p
          class="auc-address m-0"
          [innerHtml]="
            auctionDetail?.saleType?.auctionDate
              | auctionDateFormat
                : auctionDetail?.auctionStatus
                : auctionDetail?.timeZoneName
                : auctionDetail?.startDateTime
                : auctionDetail?.endDateTime
                : auctionDetail?.saleType.dateText
          "
        ></p>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="enquire-form-wrap">
      <div class="row">
        <div class="col-12">
          <h1 class="enquire-hdg">Please fill the following form.</h1>
          <h1 class="enquire-sb-hdg">
            Our team will reach out to you shortly.
          </h1>
        </div>
        <div class="col-12">
          <div class="enquire-form-outer">
            <form [formGroup]="enquireNowForm">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Full Name*</label>
                    <mat-form-field appearance="outline">
                      <input
                        formControlName="name"
                        maxlength="20"
                        matInput
                        type="text"
                        placeholder="Enter your full name"
                      />
                    </mat-form-field>
                    <control-messages
                      [control]="enquireNowForm.controls.name"
                    ></control-messages>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Email*</label>
                    <mat-form-field appearance="outline">
                      <input
                        formControlName="email"
                        maxlength="30"
                        matInput
                        type="text"
                        placeholder="Enter email"
                      />
                    </mat-form-field>
                    <control-messages
                      [control]="enquireNowForm.controls.email"
                    ></control-messages>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="row mb-4">
                    <div class="col-4 col-sm-4 pr-0">
                      <div class="form-group mb-4 no-float-fields">
                        <label class="form-label">Country code *</label>
                        <mat-select class="w-100" formControlName="isdCode">
                          <mat-option [value]="null">Select</mat-option>
                          <mat-option
                            *ngFor="let list of isdFlagList"
                            [value]="list.value"
                          >
                            <span>
                              <img
                                width="20"
                                alt="icon"
                                [src]="list.text.split(',')[0]"
                              />
                              {{ list.text.split(",")[1] }}
                            </span>
                          </mat-option>
                        </mat-select>
                        <control-messages
                          [control]="enquireNowForm.controls.isdCode"
                        ></control-messages>
                      </div>
                    </div>
                    <div class="col-7 col-sm-8">
                      <div class="form-group mb-4 no-float-fields">
                        <label class="form-label">Phone Number*</label>
                        <mat-form-field appearance="outline">
                          <input
                            formControlName="mobileNumber"
                            [maxlength]="fieldMaxLength30"
                            matInput
                            placeholder="Enter phone number"
                          />
                        </mat-form-field>
                        <control-messages
                          [control]="enquireNowForm.controls.mobileNumber"
                        ></control-messages>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Message*</label>
                    <mat-form-field appearance="outline">
                      <textarea
                        formControlName="message"
                        maxlength="500"
                        rows="8"
                        matInput
                        placeholder="Write here"
                      ></textarea>
                    </mat-form-field>
                    <control-messages
                      [control]="enquireNowForm.controls.message"
                    ></control-messages>
                  </div>
                </div>

                <div class="col-md-12" *ngIf="!isLoggedIn">
                  <div class="form-group mb-4">
                    <re-captcha
                      required
                      [formControl]="captcha"
                      [siteKey]="captchaKey"
                    ></re-captcha>
                  </div>
                </div>
                <div class="col-md-12">
                  <button
                    type="submit"
                    [disabled]="
                      (!isLoggedIn ? captcha.invalid : false) &&
                      enquireNowForm.invalid
                    "
                    class="btn btn-colored mb-2 mb-md-0 mr-2"
                    role="button"
                    (click)="onSubmit()"
                  >
                    <span
                      *ngIf="loading"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    Send Message
                  </button>
                  <button
                    type="button"
                    [disabled]="loading"
                    role="button"
                    (click)="onCancel()"
                    class="btn btn-white-border mb-2 mb-md-0"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
